<template>
  <div style="text-align: center;">
    <img src="@/assets/404_images/404.png" alt="404" style="width: 100%">
    <img src="@/assets/404_images/404_cloud.png" alt="404">
    <img src="@/assets/404_images/404_cloud.png" alt="404">
    <img src="@/assets/404_images/404_cloud.png" alt="404">
    <div>抱歉，页面无法访问...</div>
    <div>{{ message }}</div>
    <a href="" @click="$router.push({ path: '/' })">返回</a>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  computed: {
    message() {
      return '可能原因：网址有错误 > 请检查地址是否完整或存在多余字符'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/404.vue